
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'
import AdjustAmount from "./com/adjust-amount.vue";
import AdjustScore from "./com/adjust-score.vue";
import ChooseCoupon from "./com/choose-coupon.vue";
import PaidVip from "./com/paid-vip.vue";
import { getPaidLevelList, getPaidVipText } from '@/common/vip'
@Component({})
export default class extends ListViewVue {
  listType = "router";

  /** payLevelId → 等级名。列表接口不带 paidLevelInfo，等级名只能自己查 */
  paidLevelMap: Record<string, string> = {};

  async created() {
    let { error, data } = await getPaidLevelList();
    if (error) return;
    (data.list || []).forEach((item) => {
      this.paidLevelMap[item.id] = item.name;
    });
  }

  paidVipText(row) {
    return getPaidVipText(row, this.paidLevelMap[row.payLevelId]);
  }

  tablist = [
    {
      name: "全部用户",
      value: "",
    }
  ]

  activeName = ""

  /** el-table 多选选中的行，批量赠送优惠券用 */
  selectedRows: any[] = [];

  selectionChange(rows) {
    this.selectedRows = rows || [];
  }

  getGender(v) {
    switch (v) {
      case 1:
        return '男'
      case 2:
        return '女'
    }
    return '未知'
  }
  getCondition() {
    return {
      gender: "",
    }
  }

  gotoSearch(id?) {
    this.$goto(`/order/index?userId=${id}&type=0`);
  }


  gotoDetail(id) {
    this.$goto({ name: "customer-detail", query: { id: id } });
  }

  resetFilter() {
    this.find(this.getCondition())
  }

  /**
   * 预设等级是「保底」不是「封顶」：实际等级仍按累计积分算，
   * 算出结果低于预设时以预设为准，积分后来涨上去照样能超过它
   */
  async setPresetLevel(row) {
    let levelData: any;
    try {
      levelData = await this.$chooseVipGroup({
        multiple: false,
      });
    } catch (e) {
      // 用户取消
      return;
    }
    let { error, message } = await this.$post("/manager/level/set-user-preset-level", {
      levelId: levelData.id,
      id: row.id,
    });
    if (error) return this.$error(message);
    this.$success("设置成功");
    this.refresh();
  }

  async adjustAmount(row) {
    try {
      await this.$dialog({
        title: "调整用户金额",
        props: {
          width: "440px",
        },
        content: () => {
          return <AdjustAmount data={row}></AdjustAmount>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("调整成功");
    this.refresh();
  }

  async adjustScore(row) {
    try {
      await this.$dialog({
        title: "调整用户积分",
        props: {
          width: "440px",
        },
        content: () => {
          return <AdjustScore data={row}></AdjustScore>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("调整成功");
    this.refresh();
  }

  async sendPaidVip(row) {
    try {
      await this.$dialog({
        title: "赠送付费会员",
        props: {
          width: "520px",
        },
        content: () => {
          return <PaidVip data={row}></PaidVip>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("赠送成功");
    this.refresh();
  }

  async cancelPaidVip(row) {
    try {
      await this.$confirm("确定回收该用户的付费会员吗？回收后立即失去会员权益。", {
        title: "回收付费会员",
        type: "warning",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      });
    } catch (e) {
      // 用户取消
      return;
    }
    let { error, message } = await this.$post("/manager/level/cancel-paid-vip", {
      userId: row.id,
    });
    if (error) return this.$error(message);
    this.$success("回收成功");
    this.refresh();
  }

  async sendCoupon() {
    if (!this.selectedRows.length) return;
    let userIds = this.selectedRows.map((row) => row.id);

    let coupon: any;
    try {
      coupon = await this.$dialog({
        title: "赠送优惠券",
        props: {
          width: "900px",
        },
        content: () => {
          return <ChooseCoupon userCount={userIds.length}></ChooseCoupon>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }

    let { error, data, message } = await this.$post("/manager/coupon/send", {
      id: coupon.id,
      userIds,
    });
    if (error) return this.$error(message);

    if (!data.failCount) {
      this.$success(`赠送成功，共 ${data.successCount} 张`);
      return;
    }

    // 后端返回的失败只带 userId，用选中行的昵称/手机号拼成人能看的文案
    let nameMap = {};
    this.selectedRows.forEach((row) => {
      nameMap[row.id] = row.name || row.phone || `用户${row.id}`;
    });
    let failText = (data.failList || [])
      .map((item) => `${nameMap[item.id] || item.id}：${item.message}`)
      .join("\n");
    this.$success(`成功 ${data.successCount} 张，失败 ${data.failCount} 张`);
    this.$alert(failText);
  }

  async getList() {
    let data: any = { ...this.mesureData };
    // 兜一层：起止时间是日期字段，空值不能发出去（否则后端 400）
    ['startTime', 'endTime'].forEach((key) => {
      if (!data[key]) delete data[key];
    });
    return this.$post("/manager/user/list", data);
  }
}
